var normalizeTime = function normalizeTime(t) {
  return isFinite(t) ? "".concat(t, "ms") : t;
};

export default normalizeTime;